<template>
  <NuxtLink class="TextLink" :class="[mode, size, { hover, inline, error }]" :to="to">
    <LinkArrow class="icon arrow" v-if="mode === 'arrow'"></LinkArrow>
    <LinkArrowHover class="icon arrow-hover" v-if="mode === 'arrow'"></LinkArrowHover>
    <span class="text">{{ text }}</span>
    <External class="icon external" v-if="mode === 'external'"></External>
    <ExternalHover class="icon external-hover" v-if="mode === 'external'"></ExternalHover>
  </NuxtLink>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { External, LinkArrow, ExternalHover, LinkArrowHover } from '@ka-nabellinc/ka-nabell-icons'

export default defineComponent({
  components: {
    External,
    LinkArrow,
    ExternalHover,
    LinkArrowHover,
  },
  props: {
    size: {
      type: String as () => 'xs' | 'sm' | 'md' | 'lg' | 'xl',
      default: 'md'
    },
    mode: {
      type: String as () => 'default' | 'external' | 'arrow',
      default: 'default'
    },
    to: {
      type: String,
      default: null,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped>
.TextLink {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  text-decoration: none;
  cursor: pointer;
  position: relative;
}

.text {
  position: relative;
  display: inline-block;
  color: var(--semantic-colors-text-black);
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0.8px;
  text-underline-offset: 3px;
  flex: 1;
}

.TextLink:hover .text,
.TextLink.hover .text {
  color: var(--semantic-colors-text-gray);
}

.TextLink.xl .text {
  font-size: var(--font-size-sub-headline-2);
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
}

.TextLink.lg .text {
  font-size: var(--font-size-body-1);
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.14px;
}

.TextLink.md .text {
  font-size: var(--font-size-body-2);
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.13px;
}

.TextLink.sm .text {
  font-size: var(--font-size-capture-1);
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.12px;
}

.TextLink.xs .text {
    font-size: var(--font-size-capture-2);
    font-weight: 400;
    line-height: 160%;
    letter-spacing: 0.11px;
}

.hover .text::after {
  display: none;
}

.external-hover {
  display: none;
}

.arrow-hover {
  display: none;
}

.TextLink:hover .external,
.TextLink.hover .external {
  display: none;
}

.TextLink:hover .external-hover,
.TextLink.hover .external-hover {
  display: inline-block;
}

.TextLink:hover .arrow,
.TextLink.hover .arrow {
  display: none;
}

.TextLink:hover .arrow-hover,
.TextLink.hover .arrow-hover {
  display: inline-block;
}

.TextLink.inline .text {
  color: var(--semantic-colors-text-link);
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0.8px;
  text-underline-offset: 3px;
}

.TextLink.inline:hover .text,
.TextLink.inline.hover .text {
  color: var(--semantic-colors-text-link-hover);
}

.TextLink.error .text {
  color: var(--semantic-colors-text-red);
}

.icon {
  position: relative;
}

.TextLink.xs .icon {
  width: 17.6px;
  height: 17.6px;
}

.TextLink.sm .icon {
  width: 18px;
  height: 18px;
}

.TextLink.md .icon {
  width: 19.5px;
  height: 19.5px;
  top: 1.5px;
}

.TextLink.lg .icon {
  width: 21px;
  height: 21px;
  top: 2.5px;
}

.TextLink.xl .icon {
  width: 22.5px;
  height: 22.5px;
  top: 3.5px;
}
</style>